/**
 * src/components/ActiveChart.js
 * Active / WIP visualization — stacked horizontal bars showing active vs stale entities per step.
 */

export default function ActiveChart({ summary, compact, onStepClick, selectedStepIndex }) {
  if (!summary || !summary.by_step || summary.by_step.length === 0) {
    return <div style={{ fontSize: '13px', color: 'var(--text-secondary)', padding: '16px 0' }}>No active entities.</div>;
  }

  const maxCount = Math.max(...summary.by_step.map(s => s.active_count), 1);

  return (
    <div className="active-summary">
      {summary.by_step.map((step, i) => {
        const totalWidth = Math.max((step.active_count / maxCount) * 100, 2);
        const staleWidth = step.active_count > 0 ? (step.stale_count / step.active_count) * totalWidth : 0;
        const normalWidth = totalWidth - staleWidth;
        const isSelected = selectedStepIndex === step.step_index;

        return (
          <div key={i}
            className={`active-step${isSelected ? ' active-step-selected' : ''}`}
            onClick={() => onStepClick && onStepClick(step.step_index)}
            style={{ cursor: onStepClick ? 'pointer' : 'default' }}>
            <div className="active-bar-row">
              <div className="active-bar-label">
                <span style={{ fontWeight: '600', fontSize: '13px' }}>{step.label}</span>
                {!compact && (
                  <span style={{ fontSize: '11px', color: 'var(--text-tertiary)' }}>
                    {step.active_count} active{step.stale_count > 0 ? ` · ${step.stale_count} stale` : ''}
                    {step.avg_wait_seconds > 0 ? ` · avg ${step.avg_wait_formatted}` : ''}
                  </span>
                )}
              </div>
              <div className="active-bar-container">
                {normalWidth > 0 && (
                  <div className="active-bar-fill active-bar-normal" style={{ width: `${normalWidth}%` }} />
                )}
                {staleWidth > 0 && (
                  <div className="active-bar-fill active-bar-stale" style={{ width: `${staleWidth}%` }} />
                )}
                <span className="active-bar-value">{step.active_count}</span>
              </div>
            </div>
          </div>
        );
      })}

      {compact && (
        <div style={{ marginTop: '6px', fontSize: '11px', color: 'var(--text-tertiary)', display: 'flex', gap: '12px' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ width: 8, height: 8, borderRadius: 2, background: 'var(--accent, #3b82f6)', display: 'inline-block' }} />
            Active
          </span>
          {summary.total_stale > 0 && (
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span style={{ width: 8, height: 8, borderRadius: 2, background: 'var(--warning, #f59e0b)', display: 'inline-block' }} />
              Stale
            </span>
          )}
        </div>
      )}
    </div>
  );
}
